// Wrapper component allows to limit the width of the elements inside and makes sure they keep the proper distance from the viewport side edges.

import * as React from "react"
import "./style.scss"

const Wrapper = ({ children, classes = "" }) => {
  return (
    <div className={`wrapper ${classes}`}>
      {children}
    </div>
  )
}

export default Wrapper
